<div class="container page-wrapper">
    <div class="row hero-inverse">
        <div class="col-xs-12 col-sm-6 col-lg-5 padding-left-0">
            <img src={{imagePrefix}}{{contentBanner?.imageURL}} class="card-art" alt={{contentBanner?.altTxt}} role="presentation">
        </div>
        <div class="col-xs-12 col-sm-6 col-lg-7">
            <h1 [innerHTML]="contentBanner?.heading"></h1>
            <p [innerHTML]="contentBanner?.content | safeHtml" ></p><br role="presentation">
            <p class="disclaimerAD" [innerHTML]="contentBanner?.disclaimer"></p>
            <p class="title" *ngFor="let link of contentBanner?.links;let i= index;">
                <a href={{link.url}} title={{link.title}} target="{{link.target || '_self'}}">{{link.title}}</a>
            </p>
        </div>
    </div>
</div>